import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';
import SenArtisteLogo from '../components/SenArtisteLogo';

const PaymentCancel = () => {
  const { artistSlug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  return (
    <div className="min-h-screen flex items-center justify-center p-4 hero-gradient">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', duration: 0.5 }}
      >
        <Card className="glass-card max-w-md w-full" data-testid="payment-cancel">
          <CardContent className="p-8 text-center">
            <div className="w-20 h-20 mx-auto bg-red-500 rounded-full flex items-center justify-center mb-6">
              <XCircle className="w-12 h-12 text-white" />
            </div>
            
            <div className="flex items-center justify-center gap-2 mb-4">
              <SenArtisteLogo className="w-6 h-6" />
              <span className="font-syne font-bold text-xl">Sen Artiste</span>
            </div>
            
            <h1 className="font-syne text-3xl font-bold text-red-500 mb-4">
              Paiement Annulé
            </h1>
            
            <p className="text-muted-foreground mb-6">
              Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
            </p>
            
            <div className="space-y-3">
              <Button 
                className="w-full btn-primary"
                onClick={() => navigate(-1)}
                data-testid="retry-btn"
              >
                Réessayer
              </Button>
              <Button 
                variant="outline"
                className="w-full"
                onClick={() => navigate(`/${artistSlug}`)}
                data-testid="back-to-fanpage-btn"
              >
                Retour à la fanpage
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;
